var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5a1 1 0 00-2 0 4 4 0 00-4 4v11a4 4 0 004 4h12a4 4 0 004-4V9a4 4 0 00-4-4 1 1 0 10-2 0h-8zm9 3a1 1 0 01-1-1h-8a1 1 0 01-2 0 2 2 0 00-2 2v2h16V9a2 2 0 00-2-2 1 1 0 01-1 1zm3 5H6v7a2 2 0 002 2h12a2 2 0 002-2v-7z",
    fill: "#2C2D2E"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCA1QzEwIDQuNDQ3NzIgOS41NTIyOCA0IDkgNEM4LjQ0NzcyIDQgOCA0LjQ0NzcyIDggNUM1Ljc5MDg2IDUgNCA2Ljc5MDg2IDQgOVYyMEM0IDIyLjIwOTEgNS43OTA4NiAyNCA4IDI0SDIwQzIyLjIwOTEgMjQgMjQgMjIuMjA5MSAyNCAyMFY5QzI0IDYuNzkwODYgMjIuMjA5MSA1IDIwIDVDMjAgNC40NDc3MiAxOS41NTIzIDQgMTkgNEMxOC40NDc3IDQgMTggNC40NDc3MiAxOCA1SDEwWk0xOSA4QzE4LjQ0NzcgOCAxOCA3LjU1MjI4IDE4IDdIMTBDMTAgNy41NTIyOCA5LjU1MjI4IDggOSA4QzguNDQ3NzIgOCA4IDcuNTUyMjggOCA3QzYuODk1NDMgNyA2IDcuODk1NDMgNiA5VjExSDIyVjlDMjIgNy44OTU0MyAyMS4xMDQ2IDcgMjAgN0MyMCA3LjU1MjI4IDE5LjU1MjMgOCAxOSA4Wk0yMiAxM0g2VjIwQzYgMjEuMTA0NiA2Ljg5NTQzIDIyIDggMjJIMjBDMjEuMTA0NiAyMiAyMiAyMS4xMDQ2IDIyIDIwVjEzWiIgZmlsbD0iIzJDMkQyRSIvPgo8L3N2Zz4K";
export { SvgCalendar as ReactComponent };